<div class="d-flex flex-column w-100 mt-4">
    <div class="p-fluid mb-3 text-center">
        <p-selectButton [options]="availableDenominations" [(ngModel)]="selectedValue" 
            optionLabel="displayName" name="denomination" [style]="{'flex-direction':'column'}"
             (onChange)="selectOption(selectedValue)">
        </p-selectButton>
        <p-inputNumber placeholder="Gift card amount" *ngIf="customAmount" max="2000.00" [(ngModel)]="selectedAmount" inputId="currency-us" mode="currency" currency="USD" locale="en-US" styleClass="mt-2" (onBlur)="selectedAmountOutput.emit({amount: selectedAmount, value: selectedAmount})">
        </p-inputNumber>
    </div>
    <div class="p-fluid mb-3 text-center" *ngIf="eGiftVenue.promoCodes">
        <input pInputText type="text" placeholder="Enter Promo Code..."  name="name" [(ngModel)]="promoCode" class="w-100" (blur)="checkPromoCode(promoCode)" />
    </div>
    <div class="p-fluid mb-3 text-center" *ngIf="promoCodeSelected">
        <span *ngIf="+promoCodeSelected.minimumValue && +selectedAmount >= +promoCodeSelected.minimumValue">
            The Promo Code <i>{{promoCodeSelected.promoCode}}</i> saves you {{promoCodeSelected.value | currency}}
        </span>
        <span *ngIf="+selectedAmount < +promoCodeSelected?.minimumValue">
            Sorry, this promo code is only available for card purchase at or over {{promoCodeSelected.minimumValue | currency}}
        </span>
    </div>
</div>